// extracted by mini-css-extract-plugin
module.exports = {"div":"splash_screen_div__3klhB","disappear":"splash_screen_disappear__2YL2k"};